export const config: IConfig = {}

export interface IConfig {
  rawError?: boolean
}
